/*
 * DropdownSelectionWithSearch selection component
 * extends the regular Dropdown Selection
 */

import React from "react";
import { Mode, castDataType, DataType, CONTEXT_OPTIONS } from "../common.jsx";
import Select from "../../common/Select.jsx";
import { Selection } from "../form_components.jsx";
import Setting from './setting.jsx';

export default class DropdownSelectionWithSearch extends Selection {

    static get TYPE() {
        return "dropdown_selection_with_search";
    }

    static icon() {
        return <i className="fa fa-caret-down"></i>;
    }

    static get TRANSLATED_ATTRIBUTES() {
        return {
            label: 'field_default_label',
            description: 'field_default_description',
            help: null,
            blankOptionLabel: 'select_blank_option_default',
            changeConfirmText: null
        };
    }

    static defaultContent(language) {
        return Object.assign(super.defaultContent(language), {
            includeBlank: false,
            useOptionColor: true,
            enableOptionColor: false,
            blankOptionLabel: 'blankOptionLabel',
            sourcesOfPrefill: ''
        });
    }

    constructor(props){
        super(props);
    }

    renderView() {
        return (
            <div name={this.fullFieldName()}>
                {this.getLockedInformationTooltip(this.modeFillOrView() && this.isReadOnlyPrefilledAnswer(), <>
                    <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                        <span className="field-label">{this.getText('label')}</span>
                        {this.props.content.required ? " *" : null}
                        {this.helpIcon()}
                        {this.renderPrefillIcon()}
                        {this.renderOptions()}
                    </label>
                    {this.descriptionText()}
                    {!this.modeFillOrView() && this.isReadOnlyAnswer() ? this.lockedInformationDefault() : ''}
                </>)}
            </div>
        );
    }

    renderSettings() {
        return (
            <div>
                {this.renderDataGridDetails()}
                {this.isDatagridContextAvailable() && this.renderDatagridContextSettings()}
                {super.renderSettings()}
                <Setting.Checkbox name="includeBlank" label={I18n.t('field_include_blank', {scope: 'fe'})} value={this.props.content.includeBlank} onChange={this.updateSettings} />
                <Setting.TextField name="blankOptionLabel" label={I18n.t('select_blank_option_label', {scope: 'fe'})} value={this.getText('blankOptionLabel')} onChange={this.updateSettings} />

                {this.renderSourcesOfPrefillSettings()}
            </div>
        );
    }

    viewModeWholeScope() {
        return true;
    }
    customStyles = {
        singleValue: (styles, {data}) => {
            const hasLabel = data.label !== null && data.label !== undefined && data.label !== '';
            if (!hasLabel) return {};

            return {
                ...styles,
                backgroundColor: data.color ? data.color : 'transparent',
                padding: '4px 10px',
                borderRadius: '5px',
                width: 'fit-content'
            };
        }
    };

    renderOptions() {
        let options = this.getOptions().map((o, i) => {
            return {
                label: this.getOptionText(o),
                value: o.value,
                color: o.color,
            };
        });

        if (this.props.content.includeBlank) {
            options = [{label: this.getText('blankOptionLabel'), value: ""}].concat(options);
        }

        return (
            <div style={{ position: "relative" }}>
                <input type="hidden" name={this.fullFieldName()} value={this.getAnswer()} />
                <Select
                    className={`multi-select-dropdown ${this.getInputClassNames()}`}
                    value={this.getAnswer()}
                    readOnly={this.props.mode != Mode.FILL}
                    disabled={(this.props.mode == Mode.FILL && this.isReadOnlyAnswer()) || this.props.disabled}
                    onChange={(v) => this.updateAnswer(v)}
                    defaultValue={this.props.content.includeBlank ? (options[0] || {}).value : undefined}
                    options={options}
                    styles={this.props.content.enableOptionColor && this.customStyles}
                    autoComplete={this.getAutoComplete()}
                />
            </div>
        );
    }

    beforeUpdateSettings(content) {
        content.useOptionColor = true
        super.beforeUpdateSettings(content);
        content.includeBlank = castDataType(content.includeBlank, DataType.BOOLEAN);

        // Blank option should be included in case the field is required
        if (content.required) {
            content.includeBlank = true;
        }
    }

    getAnswer() {
        let answer = super.getAnswer();

        // Effectively the selected answer is the first visible option unless a blank option is included
        if (!this.props.content.includeBlank && !answer) {
            answer = castDataType((this.getOptions()[0] || {}).value || '', this.props.content.dataType);
        }
        return answer;
    }
}
